import { useEffect, useState } from "react";
import DatePicker from "react-date-picker";
import Select from "react-select";
import TelerikReporting from "../../../components/TelerikReporting/TelerikReporting";
import moment from "moment";
import useLocations from "../../../Hooks/useLocations";
import Loading from "../../../components/LoadingPage/Loading";
import { Button } from "react-bootstrap";
import useItemTypes from "../../../Hooks/useItemTypes";
import useStocks from "../../../Hooks/useStocks";
import { ReactSVG } from "react-svg";
import exporticon from "../../../assets/images/export-icon.svg";
import useReports from "../../../Hooks/useReports";
interface labelOption {
  value: string;
  label: string;
}
const InventoryExpireReport = () => {
  const [selectedLoc, setSelectedLoc] = useState({ value: "", label: "All" });
  const [selectedStock, setSelectedStock] = useState({
    value: "",
    label: "All",
  });
  const [selectedType, setSelectedType] = useState({
    value: "2",
    label: "All",
  });
  const [date, setDate] = useState(
    moment(Date()).utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
  );
  const [reportKey, setReportKey] = useState(0);
  const [isIncludeZero, setIsIncludeZero] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const defaultFilter = {
    searchText: "",
    active: true,
    sortColumn: "",
    sortDirection: "",
  };
  const [searchFieldVal, setSearchFieldVal] = useState(defaultFilter);
  const [locationsList, setLocationsList] = useState<labelOption[]>([]);
  const [typesList, setTypesList] = useState<labelOption[]>([]);
  const [stocksList, setStocksList] = useState<labelOption[]>([]);
  const { getLocationsAPI, getLocationsLoading } = useLocations();
  const { getItemTypesAPI, getItemTypesLoading } = useItemTypes();
  const { getStocksAPI, getStocksLoading } = useStocks();
  const { inventoryExpireExportAPI, inventoryExpireExportLoading } =
    useReports();
  const getLocations = () => {
    getLocationsAPI(searchFieldVal)
      .then((res: any) => {
        const options = res?.map((option: any) => ({
          value: option.locationCode,
          label: option.locationName,
        }));
        setLocationsList([{ value: "", label: "All" }, ...options]);
      })
      .catch();
  };

  const getTypes = () => {
    getItemTypesAPI(searchFieldVal)
      .then((res: any) => {
        const options = res?.map((option: any) => ({
          value: option.rxTypeCode,
          label: option.rxTypeName,
        }));
        setTypesList([{ value: "2", label: "All" }, ...options]);
      })
      .catch();
  };

  const getStocks = () => {
    getStocksAPI(searchFieldVal)
      .then((res: any) => {
        const options = res?.map((option: any) => ({
          value: option.stockCode,
          label: option.stockName,
        }));
        setStocksList([{ value: "", label: "All" }, ...options]);
      })
      .catch();
  };
  const onSelectDate = (date: any) => {
    setDate(moment(date).utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"));
  };
  const handleViewReport = () => {
    setReportKey((prevKey) => prevKey + 1);
  };
  const handleExport = async () => {
    const response = await inventoryExpireExportAPI({
      expiryDate: date,
      locationId: selectedLoc?.value ? `${selectedLoc?.value}` : "",
      drxTypeId: selectedType?.value ? `${selectedType?.value}` : "2",
      stockId: selectedStock?.value ? `${selectedStock?.value}` : "",
      isActive: isActive,
      isZeroQty: isIncludeZero,
      isExport: true,
    });
    const url = URL.createObjectURL(response);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `${localStorage.getItem("profileClientId")?.toUpperCase() ?? ""}_Inventory_Expire_Report_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  };
  const cleearAll = () => {
    setDate("");
    setSelectedStock({ value: "", label: "All" });
    setSelectedType({ value: "2", label: "All" });
    setSelectedLoc({ value: "", label: "All" });
    setIsIncludeZero(false);
    setIsActive(true);
    handleViewReport();
  };
  useEffect(() => {
    getLocations();
    getTypes();
    getStocks();
  }, [searchFieldVal]);

  return (
    <>
      {getLocationsLoading ||
      getItemTypesLoading ||
      getStocksLoading ||
      inventoryExpireExportLoading ? (
        <Loading />
      ) : null}
      <div className="report-filter-wrapper" style={{ marginBottom: "20px" }}>
        <div className="report-filter-item-wrapper">
          <div className="filter-item-box">
            <label className="form-label">Expiry Date</label>
            <DatePicker
              locale="en-US"
              format="MM/dd/yyyy"
              openCalendarOnFocus={false}
              dayPlaceholder="dd"
              monthPlaceholder="mm"
              yearPlaceholder="yyyy"
              className="form-control"
              value={date}
              onChange={(date: any) => {
                onSelectDate(date);
              }}
              clearIcon={null}
              calendarIcon={<i className="bi bi-calendar"></i>}
            />
          </div>
          <div className="filter-item-box location-filter-item">
            <label className="form-label">Location</label>
            <Select
              classNamePrefix="react-select"
              options={locationsList}
              value={locationsList?.find(
                (option: any) => selectedLoc?.value === option.value
              )}
              onChange={(option: any) => {
                setSelectedLoc(option);
              }}
            />
          </div>
          <div className="filter-item-box type-filter-item">
            <label className="form-label">Type</label>
            <Select
              classNamePrefix="react-select"
              options={typesList}
              value={typesList?.find(
                (option: any) => selectedType?.value === option.value
              )}
              onChange={(option: any) => {
                setSelectedType(option);
              }}
            />
          </div>
          <div className="filter-item-box type-filter-item">
            <label className="form-label">Stock</label>
            <Select
              classNamePrefix="react-select"
              options={stocksList}
              value={stocksList?.find(
                (option: any) => selectedStock?.value === option.value
              )}
              onChange={(option: any) => {
                setSelectedStock(option);
              }}
            />
          </div>
          <div className="filter-item-box filter-checkbox-items">
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="checkbox"
                checked={isActive}
                onChange={(e) => {
                  setIsActive(e.target.checked);
                }}
              />
              <label className="form-check-label">Active</label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="checkbox"
                checked={isIncludeZero}
                onChange={(e) => {
                  setIsIncludeZero(e.target.checked);
                }}
              />
              <label className="form-check-label">Include 0 Quantity</label>
            </div>
          </div>
          <div className="filter-item-box clear-all-box">
            <Button type="button" variant="primary" onClick={handleViewReport}>
              View
            </Button>
            <button
              type="button"
              className="clear-filter-btn"
              onClick={cleearAll}
            >
              Clear All
            </button>
          </div>
        </div>
        <div className="report-export-box">
          <button
            type="button"
            className="report-export-btn"
            onClick={handleExport}
          >
            <ReactSVG className="svg-box" wrapper="span" src={exporticon} />{" "}
            Export
          </button>
        </div>
      </div>
      <TelerikReporting
        key={reportKey}
        params={{
          expiryDate: date,
          locationId: selectedLoc?.value ? `${selectedLoc?.value}` : "",
          drxTypeId: selectedType?.value ? `${selectedType?.value}` : "2",
          stockId: selectedStock?.value ? `${selectedStock?.value}` : "",
          isActive: isActive,
          isZeroQty: isIncludeZero,
          isExport: "false",
        }}
        reportName="ExpiredInventoryReport.trdp"
        reportEndPoint="reports/expiredinventory/get"
      />
    </>
  );
};

export default InventoryExpireReport;
